import { ToolBase } from "../../agents/base/toolBase";
import { ToolDescription } from "../../agents/base/toolDescription";
import { searchPromptSections } from "../core/search";
import { PromptSearchParamsSchema, } from "./promptSearch.schema";
export function createPromptSearchTool(sections) {
    return new PromptSearchTool(sections);
}
class PromptSearchTool extends ToolBase {
    constructor(sections) {
        super();
        this.name = "promptSearch";
        this.description = new ToolDescription("promptSearch", "Search the prompt library and return section IDs.", PromptSearchParamsSchema);
        this.paramsSchema = PromptSearchParamsSchema;
        this._sections = sections;
        this.systemPromptDescription = this.buildSystemPromptDescription();
    }
    buildSystemPromptDescription() {
        const allTags = [...new Set(this._sections.flatMap(s => s.tags))].sort();
        return [
            "### promptSearch",
            "Search the prompt library (long-form guidance) and return matching section IDs.",
            "",
            "Use when you need detailed guardrails or examples beyond what's in the system prompt.",
            "Typical queries:",
            '- "number formats currency percent"',
            '- "fill down absolute references"',
            '- "waterfall chart best practices"',
            "",
            "Then call **promptGet** with the returned IDs to retrieve full text.",
            "",
            `Available tags: ${allTags.join(", ")}`,
        ].join("\n");
    }
    async execute(params) {
        const limit = typeof params.limit === "number" ? Math.min(20, params.limit) : 8;
        const results = searchPromptSections({
            sections: this._sections,
            query: params.query,
            tags: params.tags,
            limit,
        });
        return { results };
    }
}
